import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import css from './ReportCardPreviewModal.module.css';

export default function ReportCardPreviewModal({ url, title, downloadName, onClose }) {
  useEffect(() => {
    if (!url) return undefined;
    const handleKeyDown = event => {
      if (event.key === 'Escape') onClose();
    };
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [url, onClose]);

  if (!url) return null;

  return (
    <div className={css.overlay} onMouseDown={onClose}>
      <section
        className={`${css.modal} BubblePopIn`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="report-card-preview-title"
        onMouseDown={event => event.stopPropagation()}
      >
        <header className={css.header}>
          <div className={css.heading}>
            <span className={css.eyebrow}>PDF Preview</span>
            <h2 id="report-card-preview-title">{title}</h2>
          </div>
          <button type="button" className={css.iconButton} onClick={onClose} aria-label="Close preview" title="Close preview">
            <CloseIcon />
          </button>
        </header>

        <div className={css.viewer}>
          <iframe src={url} title={`${title} PDF preview`} />
        </div>

        <footer className={css.footer}>
          <a className={css.footerButton} href={url} target="_blank" rel="noreferrer">
            <OpenInNewIcon /> Open in new tab
          </a>
          {downloadName && (
            <a className={css.footerButton} href={url} download={downloadName}>
              <DownloadIcon /> Download
            </a>
          )}
          <button type="button" className={css.closeButton} onClick={onClose}>Done</button>
        </footer>
      </section>
    </div>
  );
}
